"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttemptStatus = void 0;
exports.getAttemptStatuses = getAttemptStatuses;
exports.getAttemptStatusFrom = getAttemptStatusFrom;
var AttemptStatus;
(function (AttemptStatus) {
    AttemptStatus["Assigned"] = "assigned";
    AttemptStatus["Open"] = "open";
    AttemptStatus["InProgress"] = "in_progress";
    AttemptStatus["Submitted"] = "submitted";
    AttemptStatus["Closed"] = "closed";
})(AttemptStatus || (exports.AttemptStatus = AttemptStatus = {}));
function getAttemptStatuses() {
    return [
        AttemptStatus.Assigned,
        AttemptStatus.Open,
        AttemptStatus.InProgress,
        AttemptStatus.Submitted,
        AttemptStatus.Closed,
    ];
}
function getAttemptStatusFrom(value) {
    return getAttemptStatuses().find(function (type) { return type === value; });
}
